export default __webpack_public_path__ + "assets/images/38e906cc9f4c4ff44e7ef507f70337ed.svg";